export default barcode => {
  var regexp = /^\/{1}[0-9A-Z+-.]{7}$/;

  return regexp.test(barcode);
};
